/**
 * Converts service ingest log file error to frontend format
 */
const serviceIngestLogFileErrorToIngestLogFileError = (serviceError) => ({
    fileName: serviceError.file_name,
    error: serviceError.error
});
/**
 * Converts service ingest log daily summary to frontend format
 */
const serviceIngestLogDailySummaryToIngestLogDailySummary = (serviceSummary) => ({
    date: serviceSummary.date,
    totalRows: serviceSummary.total_rows,
    errorRows: serviceSummary.error_rows,
    filesByStatus: serviceSummary.files_by_status,
    fileErrors: serviceSummary.file_errors?.map(serviceIngestLogFileErrorToIngestLogFileError)
});
/**
 * Converts service ingest log summary to frontend format
 */
const serviceIngestLogSummaryToIngestLogSummary = (serviceSummary) => ({
    dmpOrgId: serviceSummary.dmp_org_id,
    dailySummaries: serviceSummary.daily_summaries?.map(serviceIngestLogDailySummaryToIngestLogDailySummary)
});
/**
 * Converts service DMP provider info to frontend format
 */
export const serviceDmpProviderInfoToDmpProviderInfo = (serviceProvider) => ({
    dmpName: serviceProvider.dmp_name,
    orgId: serviceProvider.org_id,
    dmpCode: serviceProvider.dmp_code,
    ingestBucketName: serviceProvider.ingest_bucket_name,
    ingestCloudProvider: serviceProvider.ingest_cloud_provider,
    lastSuccessfulDelivery: serviceProvider.last_successful_delivery,
    nextScheduledDelivery: serviceProvider.next_scheduled_delivery,
    bucket: serviceProvider.bucket,
    daysSinceLastIngest: serviceProvider.days_since_last_ingest,
    numHealthySegments: serviceProvider.num_healthy_segments,
    numExpiringSegments: serviceProvider.num_expiring_segments,
    numExpiredSegments: serviceProvider.num_expired_segments,
    ingestLogSummary: serviceProvider.ingest_log_summary
        ? serviceIngestLogSummaryToIngestLogSummary(serviceProvider.ingest_log_summary)
        : undefined
});
//# sourceMappingURL=providers.js.map